import React from 'react'
import LayoutDefault from 'common/layout/layout-default'
import Navigation from 'common/navigation/navigation'
import { RouteComponentProps } from '@reach/router'

export const NotFoundPage: React.FC<RouteComponentProps & { default?: boolean }> = () => {
    return <LayoutDefault navigation={<Navigation />} pageTitle={'404'} />
}
